<template>
  <div>
    <guide></guide>
  </div>
</template>

<script>
import {authorize, getConfigInfo} from '../../service/getData'
import {setAccountInfo, setCheckLoginInfo, setConfig, setLoginInfo, setToken} from '../../util/auth'
import guide from '../../components/chat/guide'

export default {
  name: 'loginZh',
  components: {
    guide
  },
  data () {
    return {
      accountName: 'ics-sinochem', // 企业账号信息
      initTime: Date.now(), // 进入当前页面时间（单位：毫秒）
      minLoadingTime: 3000, // 页面最小停留时间（单位：毫秒）
      isHomeBack: false // 是否从首页退回
    }
  },
  methods: {
    // 登录
    login () {
      let that = this
      let flag = false
      window.appReady = function () {
        // 获取配置信息
        that.getConfigInfoFn()
        flag = true
      }
      if (!flag) {
        that.getConfigInfoFn()
      }
    },
    // 获取配置信息
    getConfigInfoFn () {
      let params = {
        account: this.accountName
      }
      getConfigInfo(params).then(res => {
        if (res.code === 0) {
          // 获取code
          this.getCode(res.data.appSubAppId, res.data.appClientId)
          // 存储配置信息
          setConfig(res.data)
        } else {
          this.$router.push({
            path: '/error',
            query: {
              msg: res.msg
            }
          })
        }
      })
    },
    // 获取code
    getCode (subAppId, clientId) {
      let params = {
        subAppId,
        clientId
      }
      let that = this
      let sinochem = window.sinochem || null
      sinochem.exec('getIAMCode', params, function (responseData) {
        const data = JSON.parse(responseData).data
        const code = data.code
        if (code !== '' && code !== null && code !== undefined) {
          sessionStorage.setItem('dialogCode', code)
          // 验证登录
          that.checkLogin(code)
        } else {
          that.$router.push({
            path: '/error',
            query: {
              msg: '网络出现异常，请返回后重新进入应用。'
            }
          })
        }
      })
    },
    // 验证登录
    checkLogin (code) {
      let params = {
        code,
        account: this.accountName
      }
      authorize(params).then(res => {
        if (res.code === 0) {
          // 保存token
          setToken(res.data.token)
          // 保存登录信息
          setLoginInfo(res.data)
          // 保存登录验证信息
          setCheckLoginInfo(res.data)
          // 存储登录企业账号信息
          setAccountInfo(this.accountName)

          if (Date.now() - this.initTime >= this.minLoadingTime) {
            // 如果页面加载时间大于当前最小等待时间，跳转首页
            this.$router.push({
              path: '/'
            })
          } else {
            // 如果未到最小等待时间，等待完剩余时间，跳转首页
            let residueTime = this.initTime + this.minLoadingTime - Date.now() // 剩余时间
            let that = this
            setTimeout(function () {
              that.$router.push({
                path: '/'
              })
            }, residueTime)
          }
        } else {
          this.$router.push({
            path: '/error',
            query: {
              msg: res.msg
            }
          })
        }
      })
    }
  },
  mounted () {
    if (!this.isHomeBack) {
      // 登录
      this.login()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name === 'chatDetail' || from.name === 'error') {
        vm.isHomeBack = true
        vm.$router.go(-1)
      } else {
        vm.isHomeBack = false
      }
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/enterpriseLogin/loginZh.vue